module.exports = __webpack_public_path__ + "img/thumbnail_RedFox_f_albino.3c856af9.png";